// extracted by mini-css-extract-plugin
module.exports = {"title":"m_r","cards":"m_s"};